module.exports = __webpack_public_path__ + "img/bx-book-reader.b378225b.svg";